export default __webpack_public_path__ + "static/media/435.2bfd1519.png";